<template>
  <BaseDialogForm
    v-model="showAddCustomerForm"
    :title="`Add ${customerModule.customer} and ${customerAddressModule.customerAddress}`"
    :nonFieldErrors="formErrors.non_field_errors"
  >
    <template #content>
      {{ formErrors.non_field_errors }}
      <v-form
        v-model="isValid"
        ref="integrationCustomerForm"
        :key="formCount"
        @submit.prevent="submitForm"
      >
        <v-row class="ma-0">
          <v-col cols="6" lg="6">
            <p class="text-caption text-truncate mb-0">
              actual value: {{ actualCustomerDetails.customer_name }}
            </p>
            <InputField
              id="name"
              v-model="customerDetails.customer_name"
              :label="`${customerModule.customer} Name`"
              name="name"
              :required="true"
              :error-messages="formErrors.customer_name"
              @input="delete formErrors.customer_name"
            />
          </v-col>
          <v-col cols="6" lg="6">
            <p class="text-caption text-truncate mb-0">
              actual value: {{ actualCustomerDetails.customer_code }}
            </p>
            <InputField
              id="code"
              v-model="customerDetails.customer_code"
              :label="`${customerModule.customer} Code`"
              :required="true"
              name="code"
              :error-messages="formErrors.customer_code"
              @input="delete formErrors.customer_code"
            />
          </v-col>
          <v-col cols="12" lg="6">
            <p class="text-caption text-truncate mb-0">
              actual value: {{ actualCustomerDetails.branch_code }}
            </p>
            <SelectField
              id="branch"
              type="number"
              v-model="customerDetails.branch_code"
              :items-list="branchList"
              name="branch"
              item-text="name"
              item-value="id"
              :label="`${configurationModule.branch}*`"
              :rules="[
                (val) => !!val || `${configurationModule.branch} is required`,
              ]"
              :error-messages="formErrors.branch_code"
              @input="delete formErrors.branch_code"
            />
          </v-col>
          <v-col cols="12" lg="12" class="d-flex align-center">
            <!-- <p class="text-caption text-truncate mb-0">
              actual value: {{ actualCustomerDetails.whatsapp_notification }}
            </p> -->
            <SwitchField
              id="whatsapp_notification"
              v-model="customerDetails.whatsapp_notification"
              inset
              name="whatsapp_notification"
              hide-details
              label="WhatsApp Notification"
              :error-messages="formErrors.whatsapp_notification"
              @input="delete formErrors.whatsapp_notification"
            ></SwitchField>
          </v-col>
          <v-col cols="12" lg="12">
            <p class="text-caption text-truncate mb-0">
              actual value: {{ actualCustomerDetails?.contact_number }}
            </p>
            <InputField
              id="contact_number"
              type="number"
              v-model="customerDetails.contact_number"
              :label="
                customerDetails.whatsapp_notification
                  ? 'Contact Number*'
                  : 'Contact Number'
              "
              name="contact_number"
              :rules="
                customerDetails.whatsapp_notification
                  ? [
                      (val) => !!val || 'Contact Number is required',
                      (val) =>
                        !val ||
                        (val.length >= 9 && val.length <= 12) ||
                        'Contact number should be between 9 to 12 digits!',
                    ]
                  : [
                      (val) =>
                        !val ||
                        (val.length >= 9 && val.length <= 12) ||
                        'Contact number should be between 9 to 12 digits!',
                    ]
              "
              :error-messages="formErrors.contact_number"
              @input="delete formErrors.contact_number"
            />
          </v-col>
          <v-col cols="12" lg="12" class="d-flex align-center">
            <!-- <p class="text-caption text-truncate mb-0">
              actual value: {{ actualCustomerDetails.email_notification }}
            </p> -->
            <SwitchField
              id="email_notification"
              v-model="customerDetails.email_notification"
              inset
              name="email_notification"
              hide-details
              :required="true"
              label="E-mail Notification"
              :error-messages="formErrors.email_notification"
              @input="delete formErrors.email_notification"
            ></SwitchField>
          </v-col>
          <v-col cols="12" lg="12">
            <p class="text-caption text-truncate mb-0">
              actual value: {{ actualCustomerDetails.contact_email }}
            </p>
            <InputField
              id="contact_email"
              v-model="customerDetails.contact_email"
              :label="
                customerDetails.email_notification
                  ? 'Contact e-mail*'
                  : 'Contact e-mail'
              "
              name="contact_email"
              :rules="
                customerDetails.email_notification
                  ? [
                      (val) => !!val || 'Contact e-mail is required',
                      (v) => !v || emailValidation(v) || 'Invalid email id',
                    ]
                  : [(v) => !v || emailValidation(v) || 'Invalid email id']
              "
              :error-messages="formErrors.contact_email"
              @input="delete formErrors.contact_email"
            />
          </v-col>
          <v-col cols="12" class="d-flex align-center py-md-0">
            <span class="text-subtitle-2 font-weight-bold">
              Customer Address Info
            </span>
          </v-col>
          <v-col cols="12" lg="7">
            <v-card outlined class="pa-6 rounded-lg">
              <v-row>
                <v-col cols="12">
                  <span class="text-subtitle-1 font-weight-bold">
                    Location Information
                  </span>
                </v-col>
                <v-col cols="12" lg="6">
                  <p class="text-caption text-truncate mb-0">
                    actual value:{{
                      actualCustomerDetails?.address?.location_id
                    }}
                  </p>
                  <InputField
                    id="location_id"
                    label="Location ID"
                    :required="true"
                    name="location_id"
                    :error-messages="
                      formErrors &&
                      formErrors.address &&
                      formErrors.address.location_id
                        ? formErrors.address.location_id
                        : []
                    "
                    v-model="customerDetailsAddress.location_id"
                    @input="delete formErrors?.address?.location_id"
                  />
                </v-col>
                <v-col cols="12" lg="6">
                  <p class="text-caption text-truncate mb-0">
                    actual value:{{
                      actualCustomerDetails?.address?.address_info
                    }}
                  </p>
                  <InputField
                    id="address_info"
                    type="text"
                    name="address_info"
                    label="Building / Apartment"
                    :error-messages="
                      formErrors &&
                      formErrors.address &&
                      formErrors.address.address_info
                        ? formErrors.address.address_info
                        : []
                    "
                    v-model="customerDetailsAddress.address_info"
                    @input="delete formErrors?.address?.address_info"
                  />
                </v-col>
                <v-col cols="12" lg="12">
                  <p class="text-caption text-truncate mb-0">
                    actual value:{{ actualCustomerDetails?.address?.address }}
                  </p>
                  <v-text-field
                    ref="customerAddress"
                    outlined
                    id="customerAddress"
                    name="address"
                    placeholder="Address*"
                    hide-details="auto"
                    dense
                    background-color="background_color"
                    :rules="[(v) => !!v || `Address is required`]"
                    :error-messages="
                      formErrors &&
                      formErrors.address &&
                      formErrors.address.address
                        ? formErrors.address.address
                        : []
                    "
                    v-model.trim="customerDetailsAddress.address"
                    @input="
                      delete formErrors?.address?.address;
                      delete formErrors?.address?.coordinates;
                    "
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="6">
                  <p class="text-caption text-truncate mb-0">
                    actual value:{{
                      actualCustomerDetails?.address?.coordinates?.latitude
                    }}
                  </p>
                  <InputField
                    id="latitude"
                    type="text"
                    name="latitude"
                    label="Latitude"
                    :class="'unassigned lighten-3'"
                    :required="true"
                    :error-messages="
                      formErrors &&
                      formErrors.address &&
                      formErrors.address.coordinates &&
                      formErrors.address.coordinates.latitude
                        ? formErrors.address.coordinates.latitude
                        : []
                    "
                    v-model.number="customerDetailsAddressCoordinates.latitude"
                    @input="delete formErrors?.address?.coordinates?.latitude"
                  ></InputField>
                </v-col>
                <v-col cols="12" lg="6">
                  <p class="text-caption text-truncate mb-0">
                    actual value:{{
                      actualCustomerDetails?.address?.coordinates?.longitude
                    }}
                  </p>
                  <InputField
                    id="longitude"
                    type="text"
                    name="longitude"
                    label="Longitude"
                    :class="'unassigned lighten-3'"
                    :required="true"
                    v-model.number="customerDetailsAddressCoordinates.longitude"
                    :error-messages="
                      formErrors &&
                      formErrors.address &&
                      formErrors.address.coordinates &&
                      formErrors.address.coordinates.longitude
                        ? formErrors.address.coordinates.longitude
                        : []
                    "
                    @input="delete formErrors?.address?.coordinates?.longitude"
                  ></InputField>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" lg="5">
            <v-card outlined class="pa-6 rounded-lg h-100">
              <v-row>
                <v-col cols="12">
                  <span class="text-subtitle-1 font-weight-bold">
                    Contact Information
                  </span>
                </v-col>
                <v-col cols="6" lg="6">
                  <p class="text-caption text-truncate mb-0">
                    actual value:{{
                      actualCustomerDetails?.address?.contact_person
                    }}
                  </p>
                  <InputField
                    id="contact_person"
                    label="Contact Person"
                    class="background-white"
                    name="contact_person"
                    :error-messages="
                      formErrors &&
                      formErrors.address &&
                      formErrors.address.contact_person
                        ? formErrors.address.contact_person
                        : []
                    "
                    v-model="customerDetailsAddress.contact_person"
                    @input="delete formErrors?.address?.contact_person"
                  ></InputField>
                </v-col>

                <v-col cols="6" lg="6">
                  <p class="text-caption text-truncate mb-0">
                    actual value:{{
                      actualCustomerDetails?.address?.contact_number
                    }}
                  </p>
                  <InputField
                    id="contact_number"
                    type="number"
                    label="Contact Number"
                    class="background-white"
                    name="contact_number"
                    :rules="[
                      (val) =>
                        !val ||
                        (val.length >= 9 && val.length <= 12) ||
                        'Contact number should be between 9 to 12 digits!',
                    ]"
                    :error-messages="
                      formErrors &&
                      formErrors.address &&
                      formErrors.address.contact_number
                        ? formErrors.address.contact_number
                        : []
                    "
                    v-model="customerDetailsAddress.contact_number"
                    @input="delete formErrors?.address?.contact_number"
                  ></InputField>
                </v-col>
                <v-col cols="12">
                  <p class="text-caption text-truncate mb-0">
                    actual value:{{
                      actualCustomerDetails?.address?.contact_email
                    }}
                  </p>
                  <InputField
                    id="contact_email"
                    type="email"
                    label="Contact Email"
                    class="background-white"
                    name="contact_email"
                    :rules="[
                      (v) => !v || emailValidation(v) || 'Invalid email id',
                    ]"
                    :error-messages="
                      formErrors &&
                      formErrors.address &&
                      formErrors.address.contact_email
                        ? formErrors.address.contact_email
                        : []
                    "
                    v-model="customerDetailsAddress.contact_email"
                    @input="delete formErrors?.address?.contact_email"
                  ></InputField>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" lg="8">
            <v-card outlined class="pa-6 rounded-lg h-100">
              <v-row>
                <v-col cols="12">
                  <span class="text-subtitle-1 font-weight-bold">
                    Customer Availability Time
                  </span>
                </v-col>
                <v-col cols="12" class="pa-0 ma-0">
                  <v-row>
                    <v-col cols="12" lg="4">
                      <p class="text-caption text-truncate mb-0">
                        actual value:{{
                          actualCustomerDetails?.address?.from_time
                        }}
                      </p>
                      <InputField
                        id="from_time"
                        v-model="customerDetailsAddress.from_time"
                        label="From Time"
                        append-icon=""
                        name="from_time"
                        type="time"
                        :error-messages="
                          formErrors &&
                          formErrors.address &&
                          formErrors.address.from_time
                            ? formErrors.address.from_time
                            : []
                        "
                        :required="true"
                        @input="delete formErrors?.address?.from_time"
                      ></InputField>
                    </v-col>
                    <v-col cols="12" lg="4">
                      <p class="text-caption text-truncate mb-0">
                        actual value:{{
                          actualCustomerDetails?.address?.to_time
                        }}
                      </p>
                      <InputField
                        id="to_time"
                        v-model="customerDetailsAddress.to_time"
                        label="To Time"
                        name="to_time"
                        append-icon=""
                        type="time"
                        :error-messages="
                          formErrors &&
                          formErrors.address &&
                          formErrors.address.to_time
                            ? formErrors.address.to_time
                            : []
                        "
                        :required="true"
                        @input="delete formErrors?.address?.to_time"
                      ></InputField>
                    </v-col>
                    <v-col cols="12" lg="4">
                      <p class="text-caption text-truncate mb-0">
                        actual value:{{
                          actualCustomerDetails?.address?.processing_time
                        }}
                      </p>
                      <InputField
                        id="processing_time"
                        type="number"
                        class="background-white"
                        label="Processing Time"
                        name="processing_time"
                        :required="true"
                        :error-messages="
                          formErrors &&
                          formErrors.address &&
                          formErrors.address.processing_time
                            ? formErrors.address.processing_time
                            : []
                        "
                        v-model="customerDetailsAddress.processing_time"
                        @input="delete formErrors.address.processing_time"
                      ></InputField>
                    </v-col>
                    <v-col cols="12">
                      <span class="text-subtitle-1 font-weight-bold">
                        Other Information
                      </span>
                    </v-col>

                    <v-col cols="12" lg="8">
                      <p class="text-caption text-truncate mb-0">
                        actual value:{{
                          actualCustomerDetails?.address?.remarks
                        }}
                      </p>
                      <TextAreaField
                        id="remarks"
                        type="text"
                        name="remarks"
                        label="Remarks"
                        height="80"
                        :error-messages="
                          formErrors &&
                          formErrors.address &&
                          formErrors.address.remarks
                            ? formErrors.address.remarks
                            : []
                        "
                        v-model="customerDetailsAddress.remarks"
                        @input="delete formErrors?.address?.remarks"
                        outlined
                      >
                      </TextAreaField>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" lg="4">
            <p class="text-caption text-truncate mb-0">
              actual value:{{ actualCustomerDetails?.address?.days }}
            </p>
            <WeekDays
              title="Preference days"
              v-model="customerDetailsAddress.days"
              :error-messages="
                formErrors && formErrors.address && formErrors.address.days
                  ? formErrors.address.days
                  : []
              "
              @input="delete formErrors?.address?.days"
              :required="true"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template #actions>
      <SecondaryButton
        id="customerReset"
        @click="resetForm()"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
      >
      </SecondaryButton>
      <PrimaryButton
        id="customerSubmit"
        @click="submitForm()"
        :disabled="!isValid"
        btnClass="text-uppercase rounded-lg"
        name="submit"
      >
      </PrimaryButton>
    </template>
  </BaseDialogForm>
</template>

<script>
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";
import {
  emailValidation,
  deepCopy,
  loadGoogleInstance,
} from "@/utils/functions.js";
import {
  customerModule,
  customerAddressModule,
  configurationModule,
  tripPlanningModule,
} from "@/utils/moduleMapping";
import { bus } from "@/main.js";

export default {
  components: { BaseDialogForm },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    branchList: {
      type: Array,
    },
  },
  data() {
    return {
      customerModule,
      customerAddressModule,
      configurationModule,
      tripPlanningModule,
      emailValidation,
      loadGoogleInstance,
      formErrors: {
        address: {
          days: [],
          address: [],
          remarks: [],
          to_time: [],
          from_time: [],
          coordinates: {
            latitude: [],
            longitude: [],
          },
          location_id: [],
          address_info: [],
          contact_email: [],
          contact_number: [],
          contact_person: [],
          processing_time: [],
        },
      },
      customerDetailsAddress: {
        days: [],
        address: "",
        remarks: "",
        to_time: "",
        from_time: "",
        location_id: "",
        address_info: "",
        contact_email: "",
        contact_number: "",
        contact_person: "",
        processing_time: 0,
      },
      customerDetailsAddressCoordinates: {
        latitude: "",
        longitude: "",
      },
      customerDetails: {
        address: {
          days: [],
          address: "",
          remarks: "",
          to_time: "",
          from_time: "",
          coordinates: {
            latitude: "",
            longitude: "",
          },
          location_id: "",
          address_info: "",
          contact_email: "",
          contact_number: "",
          contact_person: "",
          processing_time: 0,
        },
      },
      actualFormErrors: {},
      actualCustomerDetails: { address: {} },
      formCount: 0,
      isValid: true,
    };
  },
  computed: {
    showAddCustomerForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    submitForm() {
      bus.$emit("showLoader", true);
      this.customerDetailsAddress.coordinates =
        this.customerDetailsAddressCoordinates;
      this.customerDetails.address = this.customerDetailsAddress;
      this.$api.customerAddress
        .integrationCustomerUpdate({ ...this.customerDetails })
        .then(() => {
          bus.$emit("showLoader", false);
          bus.$emit("showToastMessage", {
            message: "customer and customer address created successfully",
            color: "success",
          });
          this.closeDialog();
          this.$emit("refresh-customer-logs-list", this.oldId);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);

          if (err?.data) {
            this.formErrors = err.data;
            if (err?.data?.address) {
              if (
                this.formErrors.non_field_errors &&
                this.formErrors?.address?.non_field_errors
              ) {
                this.formErrors.non_field_errors.concat(
                  this.formErrors?.address?.non_field_errors
                );
              } else {
                this.formErrors.non_field_errors =
                  this.formErrors?.address?.non_field_errors;
              }
            }
          }
        });
    },
    closeDialog() {
      this.showAddCustomerForm = false;
      this.customerDetailsAddress = {
        days: [],
        address: "",
        remarks: "",
        to_time: "",
        from_time: "",
        location_id: "",
        address_info: "",
        contact_email: "",
        contact_number: "",
        contact_person: "",
        processing_time: 0,
      };
      this.customerDetailsAddressCoordinates = {
        latitude: "",
        longitude: "",
      };
      this.customerDetails = {
        address: {
          days: [],
          address: "",
          remarks: "",
          to_time: "",
          from_time: "",
          coordinates: {
            latitude: "",
            longitude: "",
          },
          location_id: "",
          address_info: "",
          contact_email: "",
          contact_number: "",
          contact_person: "",
          processing_time: 0,
        },
      };
      this.formErrors = {
        address: {
          days: [],
          address: [],
          remarks: [],
          to_time: [],
          from_time: [],
          coordinates: {
            latitude: [],
            longitude: [],
          },
          location_id: [],
          address_info: [],
          contact_email: [],
          contact_number: [],
          contact_person: [],
          processing_time: [],
        },
      };
      this.nonFieldError = [];
    },
    setAutoComplete() {
      const interval = setInterval(async () => {
        if (this.$refs.customerAddress && window.google && window.google.maps) {
          clearInterval(interval);
          let input = document.getElementById("customerAddress");

          this.autocomplete = new window.google.maps.places.Autocomplete(input);

          if (this.userDetails?.preferred_branch?.country_code) {
            this.autocomplete.setComponentRestrictions({
              country: [this.userDetails.preferred_branch.country_code],
            });
          } else {
            this.autocomplete.setComponentRestrictions({
              country: ["AE"],
            });
          }

          this.autocomplete.addListener("place_changed", () => {
            let place = this.autocomplete.getPlace();
            let lat = place.geometry.location.lat().toFixed(6);
            let lon = place.geometry.location.lng().toFixed(6);

            this.customerDetailsAddress.address =
              place.name + ", " + place.formatted_address;
            this.customerDetailsAddressCoordinates.latitude = parseFloat(lat);
            this.customerDetailsAddressCoordinates.longitude = parseFloat(lon);
          });
        } else {
          loadGoogleInstance();
        }
      }, 100);
    },
    resetForm() {
      this.customerDetails = deepCopy(this.actualCustomerDetails);
      // { ...this.actualCustomerDetails };
      this.formErrors = deepCopy(this.actualFormErrors);
      // { ...this.actualFormErrors };
      if (this.customerDetails.branch_code) {
        let selectBranch = this.branchList.find(
          (branch) =>
            branch.code.toLowerCase() ==
            this.customerDetails.branch_code.toLowerCase()
        );

        if (selectBranch) {
          this.customerDetails.branch_code = selectBranch.id;
        } else {
          this.customerDetails.branch_code = null;
        }
      }
    },
    populateCustomerIntegrationForm(id) {
      this.$api.integration
        .getIntegrationCustomerDetails(id)
        .then((res) => {
          this.setAutoComplete();
          this.oldId = id;
          this.formErrors = res.data.error;
          this.customerDetails = res.data.payload;
          this.customerDetailsAddress = { ...this.customerDetails?.address };
          this.customerDetailsAddressCoordinates = {
            ...this.customerDetails?.address?.coordinates,
          };

          this.actualCustomerDetails = deepCopy(res.data.payload);
          // { ...res.data.payload };
          this.actualFormErrors = deepCopy(res.data.error);
          // { ...res.data.error };
          if (this.customerDetails.branch_code) {
            let selectBranch = this.branchList.find(
              (branch) =>
                branch.code.toLowerCase() ==
                this.customerDetails.branch_code.toLowerCase()
            );

            if (selectBranch) {
              this.customerDetails.branch_code = selectBranch.id;
            } else {
              this.customerDetails.branch_code = null;
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style></style>
